import Vue from 'vue'
import {helper} from "@epf/shared/helper";
import {constants} from "@epf/shared/constants";

export const httpService = {
    fetchResults: (state, offset = null, loadAllToOffset = false) => {
        if (offset !== null && offset !== 0 && loadAllToOffset) {
            const pagesToLoad = Math.ceil(offset / constants.resultsPerPage);
            const promises = [];
            for (let p = 0; p <= pagesToLoad; p++) {
                promises.push(httpService.fetchResults(state, p * constants.resultsPerPage));
            }

            return Promise.all(promises).then((results) => {
                let allData = null;
                results.forEach((result) => {
                    if (allData === null) {
                        allData = result;
                    } else {
                        allData.entities = allData.entities.concat(result.entities);
                    }
                });
                return new Promise((resolve) => resolve(allData));
            });
        }

        let request = `${window.location.origin}${state.paginationApi}&tx_epim_efapi[f]=`;

        request += encodeURIComponent(helper.generateHash(state.selectedFilterValues));

        if (offset) {
            request += `&tx_epim_efapi[start]=${offset}`;
        }

        request += `&tx_epim_efapi[num]=${constants.resultsPerPage}`;

        // const storedResponse = sessionStorage.getItem(request);
        // if (storedResponse) {
        //     return new Promise((resolve) => resolve(JSON.parse(storedResponse)));
        // }

        return Vue.http.get(request)
            .then(response => response.json())
            .then(json => {
                return new Promise((resolve) => {
                    // sessionStorage.setItem(request, JSON.stringify(json));
                    resolve(json);
                });
            });
    }
};
